import { post, get } from "./Service";
import { arrayToMap } from "./../components/Util";
import axios from "axios";

export const getJSON = (payload, onDone) => {
    post("/api/lego/recipe", payload, (res) => {
        onDone(res.data);
    });
};

export const instrument_connection = (payload, onDone) => {
    post("/api/lego/instrument-connection", payload, (res) => {
        onDone(res);
    });
};


export const printer_connection = (payload, onDone) => {
    post("/api/lego/printer-connection", payload, (res) => {
        onDone(res);
    });
};


export const download_agent = (payload, onDone) => {
    post("/api/lego/agent/download", payload, (res) => {
        onDone(res);
    });
};



export const check_printer_connection = (payload, onDone) => {
    post("/api/lego/check_printer_connection", payload, (res) => {
        onDone(res);
    });
};


export const instrument_ftp_connection = (payload, onDone) => {
    post("/api/lego/machine-connection", payload, (res) => {
        onDone(res);
    });
};

export const fetch_intrument_data = (onDone) => {
    get("/api/lego/fetch-intrument-data", (response) => {
        onDone(response);
    });
};

export const executeQuery = (payload, onDone) => {
    post("/api/lego/query", payload, (res) => {
        if (res && res.status === "SUCCESS") {
            let obj = { data: res.data.result, tabs: res.data.result_tab };
            onDone(obj);
        } else if (res && res.status === "ERROR") {
            let obj = { data: [], tabs: [], error: res.msg };
            onDone(obj);
        } else {
            let obj = { data: [], tabs: [] };
            onDone(obj);
        }
    });
};

export const executedashQuery = (payload, onDone) => {
    post("/api/lego/dashquery", payload, (res) => {
        if (res && res.status === "SUCCESS") {
            let obj = { data: res.data.result, tabs: res.data.result_tab };
            onDone(obj);
        } else if (res && res.status === "ERROR") {
            let obj = { data: [], tabs: [], error: res.msg };
            onDone(obj);
        } else {
            let obj = { data: [], tabs: [] };
            onDone(obj);
        }
    });
};

export const setObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/set-object", payload, (res) => {
        onDone(res);
    });
};
export const dmsSetObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/dms-set-object", payload, (res) => {
        onDone(res);
    });
};


export const approveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-object", payload, (res) => {
        onDone(res);
    });
};
export const dmsApproveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/dms-approve-object", payload, (res) => {
        onDone(res);
    });
};

export const approveSample = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-sample", payload, (res) => {
        onDone(res);
    });
};
export const approveTesting = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-testing", payload, (res) => {
        onDone(res);
    });
};

export const approveExperiment = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-experiment", payload, (res) => {
        onDone(res);
    });
};

export const approveDocument = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-document", payload, (res) => {
        onDone(res);
    });
};
export const approveForm = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-form", payload, (res) => {
        onDone(res);
    });
};


export const approveSection = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-section", payload, (res) => {
        onDone(res);
    });
};

export const dispatchEmail = (payload, onDone) => {
    post("/api/lego/dispatch-email", payload, (res) => {
        onDone(res);
    });
};

export const investigate = (payload, onDone) => {
    post("/api/lego/investigation-flow", payload, (res) => {
        onDone(res);
    });
};
export const testinginvestigate = (payload, onDone) => {
    post("/api/lego/testing-investigation-flow", payload, (res) => {
        onDone(res);
    });
};

export const getSetObject = (payload, onDone) => {
    post("/api/lego/upsert", payload, (res) => {
        onDone(res);
    });
};

export const getNextSequence = (payload, onDone) => {
    post("/api/lego/next-sequence", payload, (res) => {
        onDone(res);
    });
};

export const getLookups = (module_name, operation_type, operation_name, payload, onDone) => {
    post(`/api/lego/${module_name}/${operation_type}/${operation_name}`, payload, (res) => {
        if (res && res["Result Set"]) {
            let lookup = res["Result Set"];
            lookup = arrayToMap(lookup, 'family');
            onDone(lookup);
        }
    });
};

export const consignObject = (payload, onDone) => {
    post("/api/lego/consign-object", payload, (res) => {
        onDone(res);
    });
};

export const addTask = (payload, onDone) => {
    post("/api/lego/add-task", payload, (res) => {
        onDone(res);
    });
};

export const deleteAlert = (payload, onDone) => {
    post("/api/lego/delete-alert", payload, (res) => {
        onDone(res);
    });
};

export const deleteTask = (payload, onDone) => {
    post("/api/lego/delete-task", payload, (res) => {
        onDone(res);
    });
};

export const config_data = (payload, onDone) => {
    post("/api/lego/config-data", payload, (res) => {
        onDone(res);
    });
};

export const fields_remarks = (payload, onDone) => {
    post("/api/lego/fields-remarks", payload, (res) => {
        onDone(res);
    });
};


export const section_audit = (payload, onDone) => {
    post("/api/lego/section_audit", payload, (res) => {
        onDone(res);
    });
};

export const results_fields_remarks = (payload, onDone) => {
    post("/api/lego/results-fields-remarks", payload, (res) => {
        onDone(res);
    });
};
export const coa_remarks = (payload, onDone) => {
    post("/api/lego/coa-remarks", payload, (res) => {
        onDone(res);
    });
};
export const placeholder_remarks = (payload, onDone) => {
    post("/api/lego/placeholder_remarks", payload, (res) => {
        onDone(res);
    });
};
export const get_oauth_config = (payload, onDone) => {
    post("/api/security/auth/oauth2/config", payload, (res) => {
        onDone(res);
    });
};
export const insert_user_info = (payload, onDone) => {
    post("/api/lego/insert_user_info", payload, (res) => {
        onDone(res);
    });
}
export const check_user_exists = (payload, onDone) => {
    post("/api/lego/check_user_exists", payload, (res) => {
        onDone(res);
    });
}
export const uploadfile_server = (payload, onDone) => {
    console.log('payload uploadfile_server: ', payload);
    post("/api/lego/uploadfile_server", payload, (res) => {
        onDone(res);
    });
};
export const server_configuration = (payload, onDone) => {
    post("/api/lego/server_configuration", payload, (res) => {
        onDone(res);
    });
};
export const browse_server_connect = (payload, onDone) => {
    post("/api/lego/browse_server_connect", payload, (res) => {
        onDone(res);
    });
};
export const sample_fields_remarks = (payload, onDone)=>{
    
    post("/api/lego/sample-fields-remarks",payload,(res)=>{
        onDone(res);
    })
};
export const inv_sample_fields_remarks = (payload, onDone)=>{
    console.log('payload:asd ', payload);
    post("/api/lego/inv-sample-fields-remarks",payload,(res)=>{
        onDone(res);
    })
};




export const qmssetObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/qms-set-object", payload, (res) => {
        onDone(res);
    });
};

export const qmsapproveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/qms-approve-object", payload, (res) => {
        onDone(res);
    });
};

export const qmsworkflowObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    if (payload.data_json.config_workflow_id!=null){
    post("/api/lego/qms-config-workflow-object", payload, (res) => {
        onDone(res);
    });
    }
    else{
    post("/api/lego/qms-workflow-object", payload, (res) => {
        onDone(res);
    });
    }
};

export const qmsworkflowapproveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    if (payload.data_json.config_workflow_id!=null){
    post("/api/lego/qms-config-workflow-approve-object", payload, (res) => {
        onDone(res);
    });
    }
    else{
    post("/api/lego/qms-workflow-approve-object", payload, (res) => {
        onDone(res);
    });
    }
};
export const createEventReport = (payload, onDone) => {
    console.log("payload", payload);
    post("/api/lego/qms_event_report", payload, (res) => {
        onDone(res);
    });
};

export const graphreportOjbect = (payload,onDone) =>{
    console.log("payload", payload);
    post("/api/lego/qms_graph_report",payload, (res) =>{
        onDone(res);
    })
}
export const QMSinvestigate = (payload, onDone) => {
    post("/api/lego/qms-investigation-flow", payload, (res) => {
        onDone(res);
    });
};
export const ServerConnection = (onDone, onError) => {
  let resolved = false;
  const timeoutId = setTimeout(() => {
    if (!resolved) {
      resolved = true;
      console.warn("Server connection failed due to timeout.");
      onDone({ online: false, message: "Server connection failed due to timeout." });
    }
  }, 1000);
  get("/api/security/health",(response) => {
      if (!resolved) {
        resolved = true;
        clearTimeout(timeoutId);
        onDone(response);
      }
    },(error) => {
      if (!resolved) {
        resolved = true;
        clearTimeout(timeoutId);
        if (onError) onError(error);
      }
    }
  );
};

export const fetchServerTime = async () => {
  try {
    const response = await axios.get('/api/security/server-time'); 
    return response.data.serverTime;  // Assuming serverTime is in ISO string format
  } catch (error) {
    console.error('Error fetching server time:', error);
    return null;
  }};

export const qmsGridObject = (payload, onDone) => {
    // const user = JSON.parse(localStorage.getItem('user') || '{}');
    // const site_id = user?.current_auth?.site_id;
    // if (payload.is_site_restricted && !payload.site_id && site_id) {
    //     payload.site_id = site_id;
    // }
    if (!payload.grid_config_id && payload.query_path) {
        payload.grid_config_id = payload.query_path;
    }
    if (!payload.module_name && payload.module_name_from_props) {
        payload.module_name = payload.module_name_from_props;
    }
    if (payload.last_key && typeof payload.last_key === 'object') {
        if (!payload.last_key.pagination_type) {
            payload.last_key = {
                pagination_type: 'row_number',
                last_row_num: payload.data?.length || 0, // Current data count
                sort_field: payload.sort?.field_name,
                sort_direction: payload.sort?.sort_direction
            };
        }
    }
    post("/api/lego/qms-grid-object", payload, (res) => {
        onDone(res);
    });
};

export const LegoGridObject = (payload, onDone) => {
    const user = JSON.parse(sessionStorage.getItem('user') || '{}');
    const site_id = user?.current_auth?.site_id;
    const only_user_type_label = user?.current_auth?.only_user_type_label;
    if (payload.is_site_restricted && !payload.site_id && site_id && only_user_type_label !== 'Root') {
        payload.site_id = site_id;
    }
    if (!payload.grid_config_id && payload.query_path) {
        payload.grid_config_id = payload.query_path;
    }
    if (!payload.module_name && payload.module_name_from_props) {
        payload.module_name = payload.module_name_from_props;
    }
    if (payload.last_key && typeof payload.last_key === 'object') {
        if (!payload.last_key.pagination_type) {
            payload.last_key = {
                pagination_type: 'row_number',
                last_row_num: payload.data?.length || 0, // Current data count
                sort_field: payload.sort?.field_name,
                sort_direction: payload.sort?.sort_direction
            };
        }
    }
    post("/api/lego/lego-grid-object", payload, (res) => {
        onDone(res);
    });
};

export const QMSReports = (payload, onDone) => {
    post("/api/lego/qms-reports", payload, (res) => {
        onDone(res);
    });
};

export const setDocumentMessage = (payload, onDone) => {
    post("/api/lego/document_message", payload, (res) => {
        if (res && res.status === "SUCCESS") {
            let obj = { data: res.data.result, tabs: res.data.result_tab };
            onDone(obj);
        } else if (res && res.status === "ERROR") {
            let obj = { data: [], tabs: [], error: res.msg };
            onDone(obj);
        } else {
            let obj = { data: [], tabs: [] };
            onDone(obj);
        }
    });
};
